import subscriptions from './subscriptions'

export const providesNotificationsSubscriptions = subscriptions
export default providesNotificationsSubscriptions(({ children }) => children)
